import React, { Component } from 'react'
import styles from './App.styl'
import { renderRoutes } from 'react-router-config'
import TranslationContext from '../utils/TranslationContext'
import Helmet from 'react-helmet'
import { SimpleMenu, Footer } from './components'
import { object } from 'prop-types'

class App extends Component {

	static propTypes = {
		route: object,
		match: object,
		location: object
	}

	scrollToElement(nextLocation) {
		if (window) {
			const hash = nextLocation.hash ? nextLocation.hash : null
			if (hash) {
				this.scrollElement = !this.scrollElement ? window.document.querySelector(hash) : null
				if (this.scrollElement) {
					this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
					this.scrollElement = null
				}
			}
		}
	}
	componentDidMount() {
		const { location: nextLocation } = this.props
		this.scrollToElement(nextLocation)
	}
	componentDidUpdate() {
		const { location: nextLocation } = this.props
		this.scrollToElement(nextLocation)
	}
	render() {
		const { route, match: { params } } = this.props
		return (
			<div className={ styles['App'] }>
				<SimpleMenu />
				{ renderRoutes(route.routes) }
				<Footer />
			</div>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/client/website/App.js